export const GESTOR_CENTRALIZADO_BASE_URL = process.env.VUE_APP_REPORT_VTEX_BASE;
export const GESTOR_CENTRALIZADO_AGREGAR_MANUAL_PATH =
  "/hp/service-system/v1/liquidaciones/centralizado/agregar-manual";

export const SERVICE_RECORDS_BASE_URL = process.env.VUE_APP_SERVICE_RECORDS_BASE;
export const GESTOR_CENTRALIZADO_PATH =
  "/hp/service-system/v1/liquidaciones/centralizado";

export const GESTOR_CENTRALIZADO_GUARDAR_PATH =
  "/hp/service-system/v1/liquidaciones/centralizado/guardar";

export const GESTOR_CENTRALIZADO_OBSERVAR_PATH =
  "/hp/service-system/v1/liquidaciones/centralizado/observar";

export const GESTOR_CENTRALIZADO_OBSERVACION_PATH =
  "/hp/service-system/v1/liquidaciones/centralizado/observacion";

export const GESTOR_CENTRALIZADO_GENERAR_PATH =
  "/hp/service-system/v1/liquidaciones/centralizado/generar";

export const GESTOR_CENTRALIZADO_PENALIDADES_CATALOGO_PATH =
  "/hp/service-system/v1/liquidaciones/penalidades/catalogo";

export const GESTOR_ESTADO_PRE_LIQUIDACION = "PRE_LIQUIDACION";
export const GESTOR_ESTADO_OBSERVADA = "OBSERVADA";
export const GESTOR_ESTADO_ACEPTADA = "ACEPTADA";
export const GESTOR_ESTADO_PENDIENTE_REVISION = "PENDIENTE_REVISION";
export const GESTOR_ESTADO_LIQUIDACION_RESUELTA = "LIQUIDACION_RESUELTA";

/** Valor numérico esperado por POST /centralizado/observacion */
export const GESTOR_ESTADO_DESTINO_ACEPTADA = 4;

export const GESTOR_CENTRALIZADO_REQUEST_TIMEOUT = 30000;

export const GESTOR_CENTRALIZADO_DEFAULT_PER_PAGE = 10;

export const GESTOR_CENTRALIZADO_DEFAULT_PERIODO = Number(
  process.env.VUE_APP_LIQUIDACION_REPORTES_DEFAULT_PERIODO || 14,
);

export const GESTOR_CENTRALIZADO_USE_MOCK =
  process.env.VUE_APP_GESTOR_CENTRALIZADO_USE_MOCK === "true";

export const MONEY_COLUMNS = [
  "costoTotalSinIgv",
  "costoTotalConIgv",
  "penalidad",
  "totalFacturarSinIgv",
  "igv",
  "totalFacturarConIgv",
];

export const RESUMEN_MONEY_COLUMNS = [
  "costoTotalSinIgv",
  "costoTotalConIgv",
  "penalidad",
  "totalFacturarSinIgv",
  "igv",
  "totalFacturarConIgv",
];

export const LIQUIDACION_TAB_BACKOFFICE = "backoffice";
export const LIQUIDACION_TAB_GESTOR_CENTRALIZADO = "gestor-centralizado";

export const MESSAGES = {
  FILTER_NRO_OS_LABEL: "Nro. OS",
  PAGE_TITLE: "Liquidaciones",
  TAB_BACKOFFICE: "Liquidaciones Backoffice",
  TAB_GESTOR_CENTRALIZADO: "Gestor centralizado",
  SIDEBAR_LIQUIDACIONES: "Liquidaciones",
  SIDEBAR_BACKOFFICE: "Liquidaciones Backoffice",
  SIDEBAR_GESTOR_CENTRALIZADO: "Gestor centralizado",
  FILTERS_TITLE: "Filtros",
  FILTER_CORTE_LABEL: "Corte",
  FILTER_ESTADO_LABEL: "Estado",
  FILTER_PROVEEDOR_LABEL: "Proveedor",
  FILTER_TIENDA_LABEL: "Tienda",
  FILTER_ESTADO_OS_LABEL: "Estado OS",
  FILTER_ESTADO_LIQUIDACION_OS_LABEL: "Estado Liquidación OS",
  SEARCH_BUTTON: "Buscar",
  CLEAR_BUTTON: "Limpiar",
  RESUMEN_TITLE: "Resumen",
  RESULTS_TITLE: "Resultados",
  EMPTY_TABLE: "No hay registros para mostrar",
  EMPTY_TABLE_FILTERED:
    "No se encontraron órdenes para los filtros seleccionados.",
  LOADING: "Cargando...",
  LOAD_TIMEOUT_ERROR:
    "No se pudo cargar la información. Verifique su conexión e intente nuevamente.",
  LOAD_ERROR: "Ocurrió un error al cargar los datos.",
  SELECT_PERIODO_HINT: "Seleccione un periodo de liquidación para consultar.",
  INVALID_PERIODO_ERROR: "Periodo inválido. Seleccione un periodo del catálogo.",
  SAVE_BUTTON: "Guardar",
  OBSERVE_BUTTON: "Pre-liquidación observada",
  GENERATE_BUTTON: "Generar liquidación",
  TOTAL_FACTURAR_LABEL: "TOTAL A FACTURAR",
  NO_CHANGES_TO_SAVE: "No hay cambios para guardar",
  SAVE_SUCCESS: "Cambios guardados correctamente",
  SAVE_ERROR: "Error al guardar cambios",
  OBSERVE_SUCCESS: "Pre-liquidación observada",
  OBSERVE_ERROR: "Error al observar la pre-liquidación",
  GENERATE_SUCCESS: "Liquidación generada",
  GENERATE_ERROR: "Error al generar liquidación",
  CONFIRM_OBS_SUCCESS: "Observación del proveedor confirmada",
  CONFIRM_OBS_ERROR: "Error al confirmar la observación",
  CONFIRM_OBS_REQUIRED:
    "Debe confirmar la observación del proveedor (ingrese sustento si corrige)",
  REVERT_SUCCESS: "Cambios revertidos",
  PENALIDAD_MODAL_TITLE: "Editar penalidades",
  PENALIDAD_SAVE_BUTTON: "Guardar",
  PENALIDAD_CANCEL_BUTTON: "Cancelar",
  PENALIDAD_DELETE_BUTTON: "Eliminar",
  PENALIDAD_SELECT_TYPE: "Debe seleccionar un tipo",
  PENALIDAD_INVALID_TYPE: "Tipo inválido",
  PENALIDAD_CATALOG_ERROR: "Error al cargar catálogo de penalidades",
  EDIT_PENALIDAD_BUTTON: "Editar",
  LIQUIDACION_LABEL: "Liquidación",
  ESTADO_LABEL: "Estado",
  SELECT_PROVEEDOR_HINT: "Seleccione un proveedor para consultar.",
  AGREGAR_MANUAL_BUTTON: "+ Agregar OS manual",
  AGREGAR_MANUAL_MODAL_TITLE: "Agregar OS a la liquidación",
  AGREGAR_MANUAL_SEARCH_PLACEHOLDER: "Ingrese el número de OS (ej. 557273-1)",
  AGREGAR_MANUAL_SEARCH_BUTTON: "Buscar",
  AGREGAR_MANUAL_SEARCH_EMPTY: "No se encontró ninguna OS con ese número.",
  AGREGAR_MANUAL_SEARCH_ERROR: "Error al buscar la OS.",
  AGREGAR_MANUAL_ADD_BUTTON: "Agregar",
  AGREGAR_MANUAL_SUCCESS: "OS agregada correctamente a la liquidación.",
  AGREGAR_MANUAL_ERROR: "No se pudo agregar la OS.",
};

export const GESTOR_CENTRALIZADO_FILTER_SLOTS = [
  "periodo",
  "proveedor",
  "tienda",
  "estadoOs",
  "estadoLiquidacionOs",
  "detSequenceId",
];

export function getDefaultPeriodoFilterOptions() {
  return [{ value: 0, text: "Todos" }];
}

export function getDefaultEstadoFilterOptions() {
  return [{ value: 0, text: "Todos" }];
}

export function getDefaultProveedorFilterOptions() {
  return [{ value: 0, text: "Elige una opción", disabled: true }];
}

export function getGestorCentralizadoTableFields() {
  return [
    { key: "codTienda", label: "Cód. Tienda", thClass: "text-center", tdClass: "text-center" },
    { key: "nombreTienda", label: "Nombre Tienda", thClass: "text-center", tdClass: "text-left gc-col-wrap" },
    { key: "usuarioProveedor", label: "Proveedor", thClass: "text-center", tdClass: "text-left gc-col-wrap" },
    { key: "estadoDescripcion", label: "Estado OS", thClass: "text-center" },
    { key: "nroOs", label: "Nro. OS", thClass: "text-center" },
    { key: "cliente", label: "Cliente", thClass: "text-center", tdClass: "text-left gc-col-wrap" },
    { key: "skuServicio", label: "SKU Servicio", thClass: "text-center" },
    { key: "servicio", label: "Servicio", thClass: "text-center", tdClass: "text-left gc-col-wrap" },
    { key: "skuProducto", label: "SKU Producto", thClass: "text-center" },
    { key: "producto", label: "Producto", thClass: "text-center", tdClass: "text-left gc-col-wrap" },
    { key: "cantidad", label: "Cant.", thClass: "text-center", tdClass: "text-right", thStyle: { minWidth: "80px" } },
    { key: "costoTotalSinIgv", label: "Costo Total (SIN IGV)", thClass: "text-center", tdClass: "text-right" },
    { key: "costoTotalConIgv", label: "Costo Total (CON IGV)", thClass: "text-center", tdClass: "text-right" },
    { key: "penalidad", label: "Penalidad", thClass: "text-center gc-th-penalidad", tdClass: "text-right" },
    { key: "totalFacturarSinIgv", label: "Tot. por facturar (SIN IGV)", thClass: "text-center", tdClass: "text-right" },
    { key: "igv", label: "IGV", thClass: "text-center", tdClass: "text-right" },
    { key: "totalFacturarConIgv", label: "Tot. por facturar (CON IGV)", thClass: "text-center", tdClass: "text-right" },
    { key: "obsProveedor", label: "Obs. Proveedor", thClass: "text-center", tdClass: "text-left gc-col-wrap" },
    { key: "obsGestor", label: "Obs. Gestor", thClass: "text-center", tdClass: "text-left gc-col-wrap" },
    { key: "estado", label: "Estado", thClass: "text-center" },
  ];
}

export function getGestorCentralizadoEditableTableFields() {
  return [
    ...getGestorCentralizadoTableFields().filter((field) => field.key !== "opciones"),
    { key: "confirmar", label: "✓", thClass: "text-center", tdClass: "text-center gc-col-actions", thStyle: { minWidth: "115px" } },
    { key: "revertir", label: "", thClass: "text-center", tdClass: "text-center gc-col-actions" },
  ];
}

export function getGestorCentralizadoDetalleFields() {
  return [
    { key: "orden", label: "#" },
    { key: "skuServicio", label: "SKU Servicio" },
    { key: "servicio", label: "Servicio", tdClass: "gc-col-wrap" },
    { key: "skuProducto", label: "SKU Producto" },
    { key: "producto", label: "Producto", tdClass: "gc-col-wrap" },
    { key: "cantidad", label: "Cant.", thClass: "text-center", tdClass: "text-right" },
    { key: "costoSinIgv", label: "Costo S/IGV", thClass: "text-center", tdClass: "text-right" },
    { key: "costoConIgv", label: "Costo C/IGV", thClass: "text-center", tdClass: "text-right" },
    { key: "totalSinIgv", label: "Total S/IGV", thClass: "text-center", tdClass: "text-right" },
    { key: "totalConIgv", label: "Total C/IGV", thClass: "text-center", tdClass: "text-right" },
  ];
}

export function getPenalidadModalFields() {
  return [
    { key: "tipoId", label: "Tipo", thStyle: { width: "220px" }, tdClass: "gc-col-wrap" },
    { key: "descripcion", label: "Descripción", tdClass: "gc-col-wrap" },
    { key: "monto", label: "Monto (S/)", class: "text-right", thStyle: { width: "120px" } },
    { key: "acciones", label: "", thStyle: { width: "100px" } },
  ];
}

export function getResumenFields() {
  return [
    { key: "costoTotalSinIgv", label: "Costo Total (SIN IGV)" },
    { key: "costoTotalConIgv", label: "Costo Total (CON IGV)" },
    { key: "penalidad", label: "Penalidad", penalidad: true },
    { key: "totalFacturarSinIgv", label: "Tot. por facturar (SIN IGV)" },
    { key: "igv", label: "IGV" },
    { key: "totalFacturarConIgv", label: "Tot. por facturar (CON IGV)" },
  ];
}
export const GESTOR_ESTADO_LIQUIDACION_OS_OBSERVADA = 3;
export const GESTOR_ESTADO_LIQUIDACION_OS_ACEPTADA = 4;

export function getDefaultEstadoOsFilterOptions() {
  return [{ value: 0, text: "Todos" }];
}

export function getEstadoLiquidacionOsFilterOptions() {
  return [
    { value: 0, text: "Todos" },
    { value: GESTOR_ESTADO_LIQUIDACION_OS_OBSERVADA, text: "Observada" },
    { value: GESTOR_ESTADO_LIQUIDACION_OS_ACEPTADA, text: "Aceptada" },
  ];
}